import { Logo } from 'mds-web-ui'
import { Hide, Flex } from '@primitives/Layout'
import { ActiveLink } from '@utils/Link'
import React from 'react'

import { Search } from '../../Search'
import { HeaderLink } from './HeaderLink'
import { MiniBanner } from '../MiniBanner'
import { NavMenu } from './NavMenu'

const LogoSection = () => {
  // Determine if the page was redirected from a previous domain
  const fromRedirect =
    typeof window !== 'undefined' &&
    window.location.search.includes('source=mds')

  return (
    <>
      <Logo LinkComponent={ActiveLink} width={[100, 125]} />

      {fromRedirect ? (
        <Hide xs s m>
          <MiniBanner>We changed our name!</MiniBanner>
        </Hide>
      ) : null}

      <Flex flex={1} display={['none', 'flex']} />
    </>
  )
}

export const HeaderMenu = ({
  color,
  iconColor,
  theme,
  searchPlaceholder = ' ',
  searchVariant = 'subtle',
  imageData,
  ...props
}) => {
  // const themeBg = theme === 'light' ? 'var(--msk-bg)' : '#000'

  return (
    <Flex
      width="100%"
      alignItems="center"
      justifyContent={['space-between', 'center']}
      gap={[3, 4]}
      {...props}
    >
      <LogoSection color={color} />

      <Hide xs s>
        <Search
          variant={searchVariant}
          placeholder={searchPlaceholder}
          iconColor={iconColor}
        />
      </Hide>

      <Hide xs s>
        <NavMenu color={color} theme={theme} imageData={imageData} />
      </Hide>
      <Hide m l>
        <Flex gap={16}>
          <HeaderLink to="/">Apps</HeaderLink>
          <HeaderLink to="/support/">Support</HeaderLink>
        </Flex>
      </Hide>
    </Flex>
  )
}
